import React from 'react'
import { differenceInDays, formatDistanceToNow } from 'date-fns'

import { RelativeTimeCard } from '@/shared/components/ui/relative-time-card'
import { getLangCode, useLocale } from '@/shared/i18n'
import { intlFormat } from '@/shared/tools/dates'

export function BasicDatetimeDistanceField(props: {
	value: string | null | undefined
}) {
	const currentLocale = useLocale()
	if (props.value) {
		const value = new Date(props.value + 'Z')
		const diff = Math.abs(differenceInDays(value, new Date()))
		if (diff > 5) {
			return (
				<RelativeTimeCard date={value} locale={getLangCode(currentLocale)}>
					<span>{intlFormat(value)}</span>
				</RelativeTimeCard>
			)
		}

		return (
			<RelativeTimeCard date={value} locale={getLangCode(currentLocale)}>
				<span>{formatDistanceToNow(value)}</span>
			</RelativeTimeCard>
		)
	}

	return '-'
}
